import Pagination from 'react-bootstrap/Pagination';

const PublicationsPaginator = ({paginator, onPaginate}) => {
    const {total_count, per_page, num_pages, page, elied_page_range} = paginator;
    const _hasNext = () => {
        return page < num_pages;
    }
    const _hasPrev = () => {
        return page > 1;
    }
    const _isFirst = () => {
        return page === 1;
    }
    const _isLast = () => {
        return page === num_pages;
    }

    const _isCurrent = (p) => {
        return p === page;
    }

    return (
        <div className="d-flex justify-content-start">
            <Pagination>
                <Pagination.First disabled={_isFirst()} onClick={() => onPaginate(1)}><i className="paginator-icon bi-chevron-bar-left"></i></Pagination.First>
                <Pagination.Prev disabled={!_hasPrev()} onClick={() => onPaginate(page - 1)}><i className="paginator-icon bi-chevron-left"></i></Pagination.Prev>
                {elied_page_range && elied_page_range.map((p) => {
                    return typeof(p) === "number" ?
                        <Pagination.Item  active={_isCurrent(p)}  key={p} onClick={() => onPaginate(p)}>{p}</Pagination.Item> :
                        <Pagination.Ellipsis />
                })}
                <Pagination.Next disabled={!_hasNext()} onClick={() => onPaginate(page + 1)}><i className="paginator-icon bi-chevron-right"></i></Pagination.Next>
                <Pagination.Last disabled={_isLast()} onClick={() => onPaginate(num_pages)}><i className="paginator-icon bi-chevron-bar-right"></i></Pagination.Last>
            </Pagination>
        </div>
    )

}

export default PublicationsPaginator;
